import { computed, makeObservable, observable } from "mobx";
import {
  BannerUserBaseInfo,
  BannerUserStatisticsInfo,
  FollowItemInfo,
  Sets,
} from "@/types/mySpace";
import { ABCStore } from "@noli/business";
import {
  fetchFollowList,
  fetchMyLikeList,
  getSetsImgs,
  getSetsList,
  getUserBaseInfo,
  getUserStatisticsInfo,
} from "../api/mySpace";
import { cloneDeep } from "lodash";

const PAGE_NUM = 20;

export interface IMySpaceStore {
  loading: boolean;
  myLikeList: any[];
  myLikeNoMore: boolean;
  followList: FollowItemInfo[];
  followNoMore: boolean;
  bannerUserBaseInfo: BannerUserBaseInfo | null;
  bannerUserStatisticsInfo: BannerUserStatisticsInfo | null;
  myLikeFirstLoad: boolean;
  followFirstLoad: boolean;
}

class MySpaceStore extends ABCStore<IMySpaceStore> implements IMySpaceStore {
  loading = false;
  // myLike
  myLikeList: any[] = [];
  myLikeNoMore = false;
  myLikeFirstLoad = true;

  // follow
  followList: FollowItemInfo[] = [];
  followNoMore = false;
  followFirstLoad = true;

  bannerUserBaseInfo = null;
  bannerUserStatisticsInfo = null;

  constructor() {
    super();
    makeObservable(this, {
      loading: observable,
      myLikeList: observable,
      myLikeNoMore: observable,
      followList: observable,
      followNoMore: observable,
      bannerUserBaseInfo: observable,
      bannerUserStatisticsInfo: observable,
      myLikeFirstLoad: observable,
      followFirstLoad: observable,
    });
  }

  get info(): IMySpaceStore {
    return this;
  }

  public setLoading(loading: boolean) {
    this.loading = loading;
  }

  public getMyLikeList = async (pageIndex: number, successCallback?: () => void) => {
    console.log("pageIndex: ", pageIndex);
    this.loading = true;
    const res = await fetchMyLikeList({
      page_index: pageIndex,
      page_size: PAGE_NUM,
      user_id: Number(0),
    });
    if (res.code == 0 && res.data) {
      const newList = res.data.list ?? [];
      this.myLikeList = [...this.myLikeList, ...newList];
      // setCurIdx(pageIndex + 1);
      this.myLikeNoMore = pageIndex * PAGE_NUM >= res.data.total;
      successCallback?.();
    } else {
      // network error
    }
    if (this.myLikeFirstLoad) this.myLikeFirstLoad = false;
    this.loading = false;
  };

  public setMyLikeList = (list: Sets[]) => {
    this.myLikeList = list;
  };

  public updateReelsImgInfo = async (idxInList: number, userId: number) => {
    // 获取改变的 图片信息 并更新 ReelsList
    console.log("idxInList", idxInList);
    const res = await getSetsImgs({
      page_index: idxInList + 1, // 第0项 是 第一页的第一个
      page_size: 1,
      user_id: Number(userId),
    });

    if (res.code == 0 && res.data) {
      const newList = cloneDeep(this.myLikeList);
      newList.splice(idxInList, 1, res.data.opus_data[0]);
      this.myLikeList = newList;
    } else {
      //error
    }
  };

  getBannerInfo = async (userId: number) => {
    console.log(userId);
    const baseInfoRes = await getUserBaseInfo({ user_id: userId });
    const statisticsInfoRes = await getUserStatisticsInfo({ user_id: String(userId) });
    if (baseInfoRes.code === 0 && statisticsInfoRes.code == 0) {
      this.bannerUserBaseInfo = baseInfoRes.data;
      this.bannerUserStatisticsInfo = statisticsInfoRes.data;
    } else {
      // error
    }
  };

  getFollowList = async (pageIndex: number, successCallback?: () => void) => {
    this.loading = true;
    const res = await fetchFollowList({
      page_index: pageIndex,
      page_size: PAGE_NUM,
    });
    if (res.code == 0 && res.data) {
      const mergeList = res.data.list ? res.data.list : [];
      this.followList = [...this.followList, ...mergeList];
      // setCurIdx(pageIndex + 1);
      this.followNoMore = pageIndex * PAGE_NUM >= res.data.counter;
      successCallback?.();
    } else {
      // network error
    }
    if (this.followFirstLoad) this.followFirstLoad = false;
    this.loading = false;
  };

  public setFollowList = (list: FollowItemInfo[]) => {
    this.followList = list;
  };
}

export const mySpaceStore = new MySpaceStore();
